import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLStatusKeys } from "Api/Queries/Merchants/useGetOrbitLStatusQuery";
import {
  postMerchantsPublicIDOrbitLTerminalCountChangeRequest,
  type RequestTerminalCountChangeDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  request: RequestTerminalCountChangeDto;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRequestTerminalCountChangeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, request }: Parameters) =>
        postMerchantsPublicIDOrbitLTerminalCountChangeRequest(
          request,
          merchantPublicID,
        ),
    ),
    onSuccess: (_data, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: orbitLStatusKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
